'use strict';

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var fallback = require('./binaryajax-browser');

var Buffer = require('buffer').Buffer;

module.exports = /*#__PURE__*/function () {
  var _binaryAjax = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var type, isOptionalTxt, resp;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (global.fetch) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", fallback(url));

          case 2:
            type = url.slice(-3).toLowerCase();
            isOptionalTxt = type === 'prj' || type === 'cpg';
            _context.prev = 4;
            _context.next = 7;
            return fetch(url);

          case 7:
            resp = _context.sent;

            if (!(resp.status > 399)) {
              _context.next = 10;
              break;
            }

            throw new Error(resp.statusText);

          case 10:
            if (!isOptionalTxt) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", resp.text());

          case 12:
            _context.next = 14;
            return resp.arrayBuffer();

          case 14:
            resp = _context.sent;
            return _context.abrupt("return", Buffer.from(resp));

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](4);

            if (!isOptionalTxt) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", false);

          case 22:
            throw _context.t0;

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 18]]);
  }));

  function binaryAjax(_x) {
    return _binaryAjax.apply(this, arguments);
  }

  return binaryAjax;
}();